var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivCale" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacionClose = true
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Crear Tipo de Contacto")]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar",
                          attrs: {
                            depressed: "",
                            disabled: !_vm.validForm || _vm.btnBloquear
                          },
                          on: {
                            click: function($event) {
                              return _vm.continuar()
                            }
                          }
                        },
                        [_vm._v("Guardar")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "v-stepper",
                {
                  model: {
                    value: _vm.e1,
                    callback: function($$v) {
                      _vm.e1 = $$v
                    },
                    expression: "e1"
                  }
                },
                [
                  _c(
                    "v-stepper-header",
                    [
                      _c(
                        "v-stepper-step",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.informacionGeneral.visible,
                              expression: "informacionGeneral.visible"
                            }
                          ],
                          attrs: {
                            complete: _vm.e1 > _vm.informacionGeneral.step,
                            step: _vm.informacionGeneral.step
                          }
                        },
                        [_vm._v("Información General")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-items",
                    { staticClass: "cardnew" },
                    [
                      _c(
                        "v-stepper-content",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.informacionGeneral.visible,
                              expression: "informacionGeneral.visible"
                            }
                          ],
                          attrs: { step: _vm.informacionGeneral.step }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md10: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "rounded-card" },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form",
                                          staticClass: "col-md-12",
                                          attrs: { "lazy-validation": "" },
                                          model: {
                                            value: _vm.validForm,
                                            callback: function($$v) {
                                              _vm.validForm = $$v
                                            },
                                            expression: "validForm"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-container",
                                            { attrs: { "grid-list-md": "" } },
                                            [
                                              _c(
                                                "div",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { md12: "" } },
                                                    [
                                                      _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "h2_title",
                                                          staticStyle: {
                                                            "margin-top":
                                                              "12px!important"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Información General\n                          "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c("br"),
                                              _c(
                                                "v-layout",
                                                { attrs: { wrap: "" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value:
                                                              "required|max:20|nombreUnico",
                                                            expression:
                                                              "'required|max:20|nombreUnico'"
                                                          }
                                                        ],
                                                        attrs: {
                                                          "error-messages": _vm.errors.collect(
                                                            "nombre"
                                                          ),
                                                          "data-vv-name":
                                                            "nombre",
                                                          label: "Nombre",
                                                          type: "text",
                                                          counter: 20,
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .nombre,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "nombre",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.nombre"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value:
                                                              "required|max:200",
                                                            expression:
                                                              "'required|max:200'"
                                                          }
                                                        ],
                                                        attrs: {
                                                          "error-messages": _vm.errors.collect(
                                                            "descripcion"
                                                          ),
                                                          "data-vv-name":
                                                            "descripcion",
                                                          label: "Descripción",
                                                          type: "text",
                                                          counter: 200,
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .descripcion,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "descripcion",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.descripcion"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.crear.titulo", {
            entidad: "Tipo de Contacto"
          }),
          mensaje: _vm.mensajeConfirmacionInactivo,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.crear.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }